import _defineProperty2 from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _LOCALE_DISPLAY_NAME_, _UPCOMING_LOCALE;
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { NeutralColors } from "../../constants/colors";
import { LANGUAGE_CODES } from "../../lib/i18n";
export var LOCALE_DISPLAY_NAME_MAP = (_LOCALE_DISPLAY_NAME_ = {}, _defineProperty2(_LOCALE_DISPLAY_NAME_, LANGUAGE_CODES.english, 'English'), _defineProperty2(_LOCALE_DISPLAY_NAME_, LANGUAGE_CODES.spanish, 'Español'), _LOCALE_DISPLAY_NAME_);
export var UPCOMING_LOCALE = (_UPCOMING_LOCALE = {}, _defineProperty2(_UPCOMING_LOCALE, LANGUAGE_CODES.french, 'Français'), _defineProperty2(_UPCOMING_LOCALE, LANGUAGE_CODES.german, 'Deutsch'), _UPCOMING_LOCALE);
export var colors = {
  positive: NeutralColors.Grey700,
  negative: NeutralColors.White
};
export var backgroundColors = {
  positive: NeutralColors.White,
  negative: NeutralColors.Grey500
};
export var ALL_LOCALE = _objectSpread(_objectSpread({}, LOCALE_DISPLAY_NAME_MAP), UPCOMING_LOCALE);
export var ALL_LOCALE_CODES = Object.keys(ALL_LOCALE);
export var SELECT_POSITIONS = {
  TOP: 'top',
  BOTTOM: 'bottom'
};